// extracted by mini-css-extract-plugin
export var standaloneTable = "_dw-0";
export var standaloneTableWithBodyFill = "_dw-1";
export var withExtraHeader = "_dw-2";